import classNames from 'classnames';
import type React from 'react';

interface FieldProps {
  label?: string;
  labelFor?: string;
  error?: { id?: string; errors?: string[] } | null;
  category?: 'optional' | undefined;
  style?: React.CSSProperties;
  children: React.ReactNode;
  'data-qe-id'?: string;
}

export function Field({ label, labelFor, error, category, style, children, 'data-qe-id': qeId }: FieldProps) {
  const fieldClasses = classNames('field', {
    'field--error': error,
  });

  return (
    <div className={fieldClasses} style={style} data-qe-id={qeId}>
      {label && (
        <label htmlFor={labelFor} className="field-label">
          {label}
          {category === 'optional' && <span className="field-label-optional"> (Optional)</span>}
        </label>
      )}
      {children}
      {error?.errors?.[0] && <div className="invalid-feedback ">{error.errors[0]}</div>}
    </div>
  );
}
